import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
// import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import '../report.css'
// import { connect } from 'react-redux';

const WHOLE_YEAR = momentHelper.getMonth() //'00'
class ReportQuotationMovement extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      loading:false,
      activePage:1,
      month: WHOLE_YEAR,
      year: momentHelper.getYear(),
      data: [],
      isRange: false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear()
    }
    this.refTableId = 'ReportQuotationMovement-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.day)
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  loadData(year='',month='',day='') {
    this.setState({loading:true})
    ReportStore.loadReportCurrentQuotationWork(year,month,day,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  loadDataRange(start='',end='') {
    ReportStore.loadReportCurrentQuotationWorkRange(start,end,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  renderStatus(status_text) {
    let result = (<span></span>)
    if (status_text=='<span class="label label-default" data-value="0">เริ่มต้น</span>') {
      result = (<span className="label label-default" data-value="0">เริ่มต้น</span>)
    }else if (status_text=='<span class="label label-warning" data-value="1">อยู่ระหว่างซ่อม</span>') {
      result = (<span className="label label-warning" data-value="1">อยู่ระหว่างซ่อม</span>)
    } else if (status_text=='<span class="label label-primary" data-value="2">รอส่งมอบรถ</span>') {
      result = (<span className="label label-primary" data-value="2">รอส่งมอบรถ</span>)
    } else if (status_text=='<span class="label label-success" data-value="3">ปิดจบงาน</span>') {
      result = (<span className="label label-success" data-value="3">ปิดจบงาน</span>)
    } else if (status_text=='<span class="label label-purple" data-value="5">ตั้งเบิก</span>') {
      result = (<span className="label label-purple" data-value="5">ตั้งเบิก</span>)
    }
    return result
  }

  renderBody() {
    let {data} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={23}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.quotation_no}</td>
              <td className='text-left'>{item.insurer_name}</td>
              <td className='text-center'>{item.insurance_policy_no}</td>
              <td className='text-center'>{item.claim_no}</td>
              <td className='text-center'>{item.surveyor}</td>
              <td className='text-center'>{item.brand}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_wage)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_part)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_amount_with_vat)}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.work_date}</td>
              <td className='text-center'>{this.renderStatus(item.status_text)}</td>
              <td className='text-center'>{item.jobdone_date}</td>
              <td className='text-center'>{item.appointment_date}</td>
              <td className='text-center'>{item.delivering_date}</td>
              <td className='text-center'>{item.delivered_by}</td>
              <td className='text-center'>{item.invoice_no}</td>
              <td className='text-center'>{item.invoice_date}</td>
              <td className='text-right'>{this.getNumberFormat(item.sum_excess)}</td>
              <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
            </tr>
          )
        })
      )
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00'||year===0) {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00'||month===0) {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00'||day===0) {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTable() {
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered table-report-kkc-income' style={{minWidth:'2000px'}}>
          <thead>
            <tr>
              <th style={{display:'none'}} className='text-center' colSpan={23}>รายงานความเคลื่อนไหวการเสนอราคา {this.getDate()}</th>
            </tr>
            <tr>
              <th colSpan={8} className='text-center'>เสนอราคา</th>
              <th colSpan={4} className='text-center'>คุมราคา</th>
              <th colSpan={7} className='text-center'>การซ่อม</th>
              <th colSpan={4} className='text-center'>การเก็บเงิน</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>เลขที่</th>
              <th className='text-center' style={{width:'300px',minWidth:'300px'}}>ชื่อประกัน</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>เลขกรมธรรม์</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>เลขเคลม/<br/>แจ้ง</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>เจ้าหน้าที่</th>
              <th className='text-center' style={{width:'90px',minWidth:'90px'}}>ยี่ห้อ</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>ทะเบียน</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>ค่าแรง<br/>อนุมัติ</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>ค่าอะไหล่<br/>อนุมัติ</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>รวม</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>รวม VAT</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>เลขที่<br/>งานซ่อม</th>
              <th className='text-center' style={{width:'90px',minWidth:'90px'}}>วันที่<br/>เริ่มซ่อม</th>
              <th className='text-center' style={{width:'90px',minWidth:'90px'}}>สถานะ</th>
              <th className='text-center' style={{width:'90px',minWidth:'90px'}}>วันที่<br/>ซ่อมเสร็จ</th>
              <th className='text-center' style={{width:'90px',minWidth:'90px'}}>วันที่<br/>นัดรับ</th>
              <th className='text-center' style={{width:'90px',minWidth:'90px'}}>วันที่<br/>ส่งรถ</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>เจ้าหน้าที่<br/>ส่งรถ</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>เลขที่<br/>ใบแจ้งหนี้</th>
              <th className='text-center' style={{width:'90px',minWidth:'90px'}}>วันที่<br/>วางบิล</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>ค่า Excess</th>
              <th className='text-center' style={{width:'100px',minWidth:'100px'}}>รวมรับสุทธิ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={8} className='text-right'>ยอดรวมสุทธิ</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('approved_wage'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('approved_part'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('approved_amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('approved_amount_with_vat'))}</th>
              <th colSpan={9} className='text-right'></th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('sum_excess'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('amount'))}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadData(this.state.year,this.state.month,val.value)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadData(this.state.year,val.value,_day)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false
    })
    this.loadData(val.value,this.state.month,_day)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานความเคลื่อนไหวการเสนอราคา.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportQuotationMovement&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportQuotationMovement&start_date='+start+'&end_date='+end+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?this.state.dayRange:this.state.day)+'/'+this.state.month+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {/* {this.renderPaging()} */}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportQuotationMovement.defaultProps = {
  show : false
}

export default ReportQuotationMovement;





// WEBPACK FOOTER //
// ./src/view/report/analysis/ReportQuotationMovement.js